module.exports = __webpack_public_path__ + "img/logo.21ba7a42.png";